import React, {FC} from 'react';
import styled from 'styled-components';

import {CardGroupModel} from '../../../models/api/cardGroupModel';
import {CardModel} from '../../../models/api/cardModel';
import {useContactDetailsContext} from '../contactDetailsContext';
import {ContactHeaderAddToGroupPopover} from './contactHeaderAddToGroupPopover';
import {ContactHeaderGroup} from './contactHeaderGroup';

/*
 * Props.
 */

interface ContactHeaderGroupsProps {
  card: CardModel;
  groups: ReadonlyArray<CardGroupModel>;
}

/*
 * Styles.
 */

const StyledPillContainerDiv = styled.div`
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
`;

/*
 * Component.
 */

export const ContactHeaderGroups: FC<ContactHeaderGroupsProps> = (props) => {
  const {card, groups} = props;
  const shouldShowAddText = groups.length === 0;
  const {isReadOnly} = useContactDetailsContext();

  // In readonly mode, do not render anything if we have no groups.
  if (isReadOnly && groups.length === 0) {
    return null;
  }

  return (
    <StyledPillContainerDiv>
      {groups.map((group) => (
        <ContactHeaderGroup key={group.id} group={group} card={card} />
      ))}
      {!isReadOnly && <ContactHeaderAddToGroupPopover card={card} shouldShowAddText={shouldShowAddText} />}
    </StyledPillContainerDiv>
  );
};
